export {default} from 'views/Users/Users'



// WEBPACK FOOTER //
// ./src/views/Administration/Users.jsx